import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";

import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./pages/home/Home";
// eslint-disable-next-line no-unused-vars
import Technology from "./pages/technology/Technology";
import Contact from "./pages/contact/Contact";
import About from "./pages/about/About";
import Retailers from "./pages/retailers/Retailers";
import Blog from "./pages/blog/Blog";
import Post from "./pages/post/Post";
import PrivacyPolicy from "./pages/privacy-policy/PrivacyPolicy";
import TermsConditions from "./pages/terms-conditions/TermsConditions";

function App() {
  return (
    <React.StrictMode>
      <Router>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          {/* TEMPORARILY DISABLED: "How it works" page. Re-enable by uncommenting the line below. */}
          {/* <Route exact path="/technology" element={<Technology />} /> */}
          <Route exact path="/retailers" element={<Retailers />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/book" element={<Contact type={'book'} />} />
          <Route exact path="/subscribe" element={<Contact type={'subscribe'} />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/blog" element={<Blog />} />
          <Route exact path="/post/:slug" element={<Post />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/terms-conditions" element={<TermsConditions />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </Router>
    </React.StrictMode>
  );
}

export default App;
